import { Modal, Spin } from 'antd';
import React, { useEffect } from 'react';
import styles from './modalLoading.module.scss';

type Props = {
	visible: boolean;
};

const ModalLoading: React.FC<Props> = ({ visible, children }) => {
	///remove scroll when modal is opened
	useEffect(() => {
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = 'auto';
		};
	}, []);

	return (
		<Modal centered closable={false} keyboard={false} maskClosable={false} visible={visible} footer={null} width='400px'>
			<Spin tip={`${_('Loading')}...`} className={styles.loadingIcon}>
				<div id='portConfiguringPortContainer' className={styles.container}>
					<span className={styles.loadingText}>{children}</span>
				</div>
			</Spin>
		</Modal>
	);
};

export { ModalLoading };
